import anime from 'animejs'

export default (targets, step, direction, horizontal = true) => {
    const duration = 1000
    const from = step === 'leave' ? 0 : 100
    const to = step === 'leave' ? 100 : 0

    const axis = horizontal
        ? 'translateX'
        : 'translateY'

    targets.style.transform = direction === 'next'
        ? `${axis}(${from}%)`
        : `${axis}(-${from}%)`

    const translateX = direction === 'next' ? `-${to}%` : `${to}%`
    const anim = anime.timeline({
        easing: 'easeInOutQuart',
        duration,
    })

    if (step === 'enter') {
        targets.classList.add('position-fixed', 'z-10')
        targets.style.top = `${document.querySelector('#navigation').clientHeight}px`
        targets.style.left = `calc(50% - ${targets.clientWidth / 2}px)`
    }

    anim.add({
        targets,
        [axis]: translateX,
    })

    return anim.finished
}

export function resetAfterEntry(target) {
    const validPagesToBreadcrumb = [
        "africa",
        "europe",
        "asia-pacific",
        "content-library",
        "research-briefs"
    ]
    target.classList.remove('position-fixed', 'z-10')
    target.style.top = ''
    scrollTo(0, 0)
    target.style.left = ''
    target.style.transform = ''
    const breadcrumbWrapper = document.querySelectorAll('.breadcrumbs-wrapper')
    const breadcrumbs = JSON.parse(target.dataset.breadcrumbs || '[]')
    const pageBreadcrumbs = document.querySelector('#page-breadcrumbs');
    if (breadcrumbs.length > 0) {
        if (validPagesToBreadcrumb.includes(breadcrumbs[0].slug)) {
            if (pageBreadcrumbs) {
                switch (breadcrumbs[0].slug) {
                    case "content-library":
                        pageBreadcrumbs.innerHTML = `<h1 class="text-xl mb-0"><a href="/content-library">Content Library</a></h1>`
                        break;
                    case "research-briefs":
                        pageBreadcrumbs.innerHTML = `<h1 class="text-xl mb-0"><a href="/research-briefs">Research articles from Africa, Asia-Pacific and Europe</a></h1>`
                        break;
                    default:
                        pageBreadcrumbs.innerHTML = breadcrumbs.map(({ name, slug }) => {
                            return `<a href="${slug}">${name}</a>`
                        }).join(' | ');
                        break;
                }
            }
        } else {
            if (pageBreadcrumbs) {
                pageBreadcrumbs.innerHTML = document.title.split("|")[0];
            }
        }
    }
    if (target.dataset.hasBreadcrumbs === '1' || (window.location.pathname === '/research-briefs' || window.location.pathname === '/content-library')) {
        breadcrumbWrapper.forEach(wrapper => {
            wrapper.classList.remove('d-none')
        })
    } else {
        breadcrumbWrapper.forEach(wrapper => {
            wrapper.classList.add('d-none')
        })
    }
}
